export enum ENativeDebugPanelEvent {
  Toggle   = 'DebugPanel:Toggle',
  Switched = 'DebugPanel:Switched'
}

export type { IEvent } from '@common/EventHandler/EventHandler'
export type { TSolutionTypes } from '@apps/StatHandler/definitions'
export { EStatHandlerEvent } from '@apps/StatHandler/definitions'
